import { useMemo } from 'react'
import { useAppSelector } from '../redux/store'
import { resolveShopMediaUrl } from '../utils/shopMedia'

/** patientId → profile pic URL, sourced from the live lobby queue (same as lobby cards). */
export function useShopPatientProfilePics() {
  const queue = useAppSelector((state) => state.lobbyPortal.queue)

  return useMemo(() => {
    const map = new Map<string, string>()
    const records = [...(queue?.checkedIn ?? []), ...(queue?.upcoming ?? []), ...(queue?.previous ?? [])]

    for (const record of records) {
      const patientId = record.visit?.patientId
      const pic = record.visit?.patient?.user?.profilePic
      if (patientId && pic && !map.has(patientId)) {
        map.set(patientId, resolveShopMediaUrl(pic) ?? pic)
      }
    }

    return map
  }, [queue])
}
